import { Component, OnInit } from '@angular/core';
declare var $: any

@Component({
  selector: 'app-contact-report',
  templateUrl: './contact-report.component.html',
  styleUrls: ['./contact-report.component.scss']
})
export class ContactReportComponent implements OnInit {

  constructor() { }

  ngOnInit() {
      
  }

  clearActionActive(){
    $(".action-menu").each(function(){
      $(this).removeClass("active")
    })
  }

  CloseModal(modalId: string){
    $("#" + modalId).modal("hide")
    this.clearActionActive()
  }

  create(event: any){
    this.clearActionActive()
    event.target.classList.add("active")

    $("#createModal").modal('show')
  }
  delete(event: any){
    this.clearActionActive()
    event.target.classList.add("active")
    $("#deleteModal").modal('show')
  }
  forward(event: any){
    this.clearActionActive()
    event.target.classList.add("active")
    $("#forwardModal").modal('show')
  }
  
  confirmCreate(){
    $("#createModal").modal('hide')
  }

  confirmForward(){
    $("#forwardModal").modal('hide')
  }

  confirmDelete(){
    $("#deleteModal").modal('hide')
  }

  confirmEmail(){
    
  }
}



// WEBPACK FOOTER //
// ./src/app/contact-report/contact-report.component.ts